import { AlertLooks, StandardAlert } from '@brandfolder/react';
import React, { useState, FunctionComponent, useEffect } from 'react';

import { useFetch } from '@api/ApiHelper';
import { Locale } from '@components/common/language_menu/languagesMap';
import { genericError } from '@components/standard-messages';
import { determineUGTLocale } from '@components/asset/modal/tabs/edit/helpers';
import CustomFieldsManagement from '@components/bulk_management/custom_fields/main';
import CustomFieldsValueManagement from '@components/bulk_management/custom_field_values/main';
import {
  getCurrentUrlLocale
} from '@components/bulk_management/user_generated_translations/BulkManagementLanguageMenuDropdown';
import { UGTAlert } from '@components/common/language_menu/UGTAlert';

interface CustomFieldKeyCount {
  /* eslint-disable @typescript-eslint/naming-convention */
  brandfolder_id: number;
  counted_assets: number;
  id: number;
  key: string;
  name: string;
  prioritized: boolean;
  translations: { [locale: string]: { name: string } };
  uniq_values: number; // -1 if no counts
  /* eslint-enable @typescript-eslint/naming-convention */
}

export const BulkCustomFields: FunctionComponent = () => {
  const [selectedCustomFieldKey, setSelectedCustomFieldKey] = useState<CustomFieldKeyCount>();
  const [ugtLocale, setUgtLocale] = useState<Locale>(
    getCurrentUrlLocale() || determineUGTLocale() || BFG.locales?.ugtLocaleDefault
  );

  const customFieldKeyCountFetch = useFetch<CustomFieldKeyCount[]>({
    url: `/api/v4/private/brandfolders/${BFG.resource?.key}/custom_field_key_counts`,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    params: { 'ugt_locale': ugtLocale },
    fetchOnMount: false
  });

  useEffect(() => {
    if (BFG.resource?.key && ugtLocale) {
      customFieldKeyCountFetch.fetch();
    }
  }, [ugtLocale]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!BFG.resource?.key || customFieldKeyCountFetch.error) {
    return (
      <StandardAlert
        look={AlertLooks.Error}
      >
        {genericError}
      </StandardAlert>
    );
  }

  return (
    <div>
      <UGTAlert locale={ugtLocale} />
      {selectedCustomFieldKey ? (
        <CustomFieldsValueManagement
          customFieldKeyKey={selectedCustomFieldKey.key}
          customFieldKeyName={selectedCustomFieldKey.name}
          setSelectedCustomFieldKey={setSelectedCustomFieldKey}
          setUgtLocale={setUgtLocale}
          ugtLocale={ugtLocale}
        />
      ) : (
        <CustomFieldsManagement
          customFieldKeys={customFieldKeyCountFetch.response}
          loading={customFieldKeyCountFetch.loading}
          setSelectedCustomFieldKey={setSelectedCustomFieldKey}
          setUgtLocale={setUgtLocale}
          ugtLocale={ugtLocale}
        />
      )}
    </div>
  );
};